import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { Site } from '../../../../common/constants/siteList'
import { IRootState } from '../../../../common/reducers'
import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import { getSearchLocationParams } from '../../../../common/utils/location'
import ItemCard from './itemCard'

interface IStateProps {
  currentSite: Site
  viewType: string
  locationParams: ILocationParams
}

const mapStateToProps = (
  state: IRootState,
  ownProps: RouteComponentProps<any>
): IStateProps => {
  const {
    common: { currentSite },
    user: { preferences },
    router: { location },
    experiments
  } = state
  const viewType = preferences.searchResultsViewType
  const locationParams = getSearchLocationParams({
    location,
    currentSite,
    experiments,
    routeMatch: ownProps.match
  })

  return {
    currentSite,
    viewType,
    locationParams
  }
}

const ItemCardContainer = connect<IStateProps, {}, any, IRootState>(
  mapStateToProps
)(ItemCard)

export default withRouter(ItemCardContainer)
